<div id="actionButtonsContainer" class="flexRowContainer">
  <button mat-icon-button (click)="backToCase()" (keydown.enter)="backToCase()"
          aria-label="Back to case">
    <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
  </button>
</div>
<div id="requestInformationContainer" class="flexColumnContainer">
  <p class="headline-small">{{ 'requestInformation.title' | translate }}</p>
  <span id="requestInformationCaseName" class="body-medium">{{ 'requestInformation.case' | translate }}
    : {{ caseRequestInformationHal.caseName }}</span>
  <span id="requestInformationClientName" class="body-medium">{{ 'requestInformation.client' | translate }}
    : {{ getFullClientName() }}</span>
  <div id="collaboratorSelectionContainer" class="flexRowContainer inputContainer">
    <mat-expansion-panel class="flexColumnContainer"
                         [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title-medium">
          <mat-icon class="material-symbols-outlined stepIcon">person</mat-icon>
          {{ 'requestInformation.collaboratorSelection.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="body-medium">{{ 'requestInformation.collaboratorSelection.description' | translate }}</p>
      <app-user-selection (userSelected)="customerSelected($event)" [prefilledUser]="caseCustomer()"
                          [caseId]="caseRequestInformationHal.caseId"
                          (userDeselected)="customerUnselected()"></app-user-selection>
      @if (isSelectedCustomerWithoutEmail()) {
        <p id="emailMissingError" class="body-medium" role="alert">
          {{ 'requestInformation.collaboratorSelection.emailMissingError' | translate }}
        </p>
      }
    </mat-expansion-panel>
  </div>
  @if (hasDocumentsWithoutFileId()) {
    <div id="openDocumentsContainer" class="flexRowContainer inputContainer">
      <mat-expansion-panel class="flexColumnContainer"
                           [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="title-medium">
            <mat-icon class="material-symbols-outlined stepIcon">pending_actions</mat-icon>
            {{ 'requestInformation.openDocuments.title' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="body-medium">{{ 'requestInformation.openDocuments.description' | translate }}</p>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'requestInformation.openDocuments.label' | translate }}</mat-label>
          <mat-select multiple [(ngModel)]="selectedDocumentsWithoutFileId">
            @for (document of documentsWithoutFileId; track document) {
              <mat-option [value]="document">
                {{ document.title }}
              </mat-option>
            }
            @if ((documentsWithoutFileId)?.length === 0) {
              <mat-option class="no-checkbox" disabled>
                <span class="body-medium">{{ 'requestInformation.openDocuments.emptyOption' | translate }}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @for (document of selectedDocumentsWithoutFileId; track document) {
          <div class="flexRowContainer formCard">
            <div class="flexColumnContainer formInfo">
              <span class="body-large formTitle">{{ document.title }}</span>
            </div>
            <button class="deselectDocumentButton" mat-icon-button (click)="deselectDocumentWithoutFileId(document)"
                    (keydown.enter)="deselectDocumentWithoutFileId(document)"
                    aria-label="Deselect Document">
              <mat-icon class="material-icons-outlined">cancel</mat-icon>
            </button>
          </div>
        }
      </mat-expansion-panel>
    </div>
  }
  <div id="collaboratorDocumentsReferenceContainer" class="flexRowContainer inputContainer">
    <mat-expansion-panel class="flexColumnContainer"
                         [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title-medium">
          <mat-icon class="material-symbols-outlined stepIcon">quick_reference</mat-icon>
          {{ 'requestInformation.collaboratorDocumentsReference.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="body-medium">{{ 'requestInformation.collaboratorDocumentsReference.description' | translate }}</p>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'requestInformation.collaboratorDocumentsReference.label' | translate }}</mat-label>
        <mat-select multiple [(ngModel)]="selectedDocumentsWithFileId">
          @for (document of documentsWithFileId; track document) {
            <mat-option [value]="document">
              {{ document.title }}
            </mat-option>
          }
          @if ((documentsWithFileId)?.length === 0) {
            <mat-option class="no-checkbox" disabled>
              <span
              class="body-medium">{{ 'requestInformation.collaboratorDocumentsReference.emptyOption' | translate }}</span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @for (document of selectedDocumentsWithFileId; track document) {
        <div class="flexRowContainer formCard">
          <div class="flexColumnContainer formInfo">
            <span class="body-large formTitle">{{ document.title }}</span>
          </div>
          <button class="deselectDocumentButton" mat-icon-button (click)="deselectDocumentWithFileId(document)"
                  (keydown.enter)="deselectDocumentWithFileId(document)"
                  aria-label="Deselect Document">
            <mat-icon class="material-icons-outlined">cancel</mat-icon>
          </button>
        </div>
      }
    </mat-expansion-panel>
  </div>
  <div id="requestAdditionalDocumentsContainer" class="flexRowContainer inputContainer">
    <mat-expansion-panel class="flexColumnContainer"
                         [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title-medium">
          <mat-icon class="material-symbols-outlined stepIcon">attach_file_add</mat-icon>
          {{ 'requestInformation.requestAdditionalDocuments.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="body-medium">{{ 'requestInformation.requestAdditionalDocuments.description' | translate }}</p>
      <div id="addAdditionalDocuments" class="flexRowContainer">
        <mat-form-field appearance="outline" class="flexGrow">
          <mat-label>{{ 'requestInformation.documents.label' | translate }}</mat-label>
          <input matInput type="text" placeholder="{{ 'requestInformation.documents.placeholder' | translate }}"
                 aria-label="Documents"
                 [formControl]="documentsFormControl" (keydown.enter)="addRequiredDocumentTitle()">
        </mat-form-field>
        <button mat-flat-button (click)="addRequiredDocumentTitle()" (keydown.enter)="addRequiredDocumentTitle()">
          {{ 'requestInformation.actions.addDocument' | translate }}
        </button>
      </div>
      <div class="flexRowContainer requestInformationList">
        @for (documentTitle of requiredDocumentTitles; track documentTitle) {
          <div class="flexRowContainer formCard">
            <div class="flexColumnContainer formInfo">
              <span class="body-large formTitle">{{ documentTitle }}</span>
            </div>
            <button class="deselectDocumentButton" mat-icon-button (click)="removeRequiredDocumentTitle(documentTitle)"
                    (keydown.enter)="removeRequiredDocumentTitle(documentTitle)"
                    aria-label="Deselect Document">
              <mat-icon class="material-icons-outlined">cancel</mat-icon>
            </button>
          </div>
        }
      </div>
    </mat-expansion-panel>
  </div>
  <div id="personalMessageContainer" class="inputContainer">
    <div class="flexRowContainer">

      <mat-expansion-panel class="flexColumnContainer"
                           [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="title-medium">
            <mat-icon class="material-symbols-outlined stepIcon">chat</mat-icon>
            {{ 'requestInformation.AddPersonalMessage.title' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="body-medium">{{ 'requestInformation.AddPersonalMessage.description' | translate }}</p>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'requestInformation.AddPersonalMessage.label' | translate }}</mat-label>
          <textarea matInput placeholder="{{ 'requestInformation.AddPersonalMessage.placeholder' | translate }}"
                    aria-label="Comment"
                    [formControl]="commentFormControl"></textarea>
        </mat-form-field>
      </mat-expansion-panel>
    </div>
  </div>
  <div id="actionsContainer" class="flexRowContainer inputContainer">
    <button
      [disabled]="!selectedCustomer || isSelectedCustomerWithoutEmail() || (!requiredDocumentTitles.length && !selectedDocumentsWithoutFileId.length && !selectedDocumentsWithFileId.length)"
      mat-flat-button
      (click)="requestInformation()"
      (keydown.enter)="requestInformation()"
    >
      {{ 'requestInformation.actions.sendRequest' | translate }}
    </button>
  </div>
</div>
